export default __webpack_public_path__ + "static/media/44.c2a35d78.jpg";